<template>
  <div class="recombination-custom-menu">
    <el-menu mode="horizontal" text-color="#fff" background-color="#1f2d3d" active-text-color="#fff"
      :default-active="activeId" :unique-opened="true" ref="menuId" @select="handleGet">
      <template v-for="(item, index) in sidebarRouters">
        <!--只有一级菜单-->
        <el-menu-item :key="item.route || item.id" :class="[
          'recombination-first-stage',
          activeMenu == item.id.toString() ? 'is-active' : '',
        ]" :style="getMenuItemStyle(item)" v-if="!item.hidden &&
  index < showIndex &&
  (!item.children ||
    !Array.isArray(item.children) ||
    (Array.isArray(item.children) && item.children.length == 0))
  " :index="item.id.toString() + '99999'" @click="setPermission(item.oldData)">
          <!--<i v-if="item.meta &&
            item.meta.icon &&
            item.meta.icon != '#' &&
            item.meta.icon != ''
            " :class="'font_family' + ' ' + item.meta.icon"></i>-->
          <span> {{ item.meta && item.meta.title && item.meta.title }}</span>
        </el-menu-item>
        <!--有多级菜单-->
        <el-submenu :key="item.route || item.id" :class="[
          'recombination-first-stage',
          activeMenu == item.id.toString() ? 'is-active' : '',
        ]" v-else-if="!item.hidden && index < showIndex" :style="getMenuItemStyle(item)" :popper-append-to-body="true"
          popper-class="top-menu-popper" menu-trigger="hover" :show-timeout="0" :hide-timeout="200"
          :index="item.id.toString() + '99999'">
          <template slot="title">
            <!--<i v-if="item.meta &&
              item.meta.icon &&
              item.meta.icon != '#' &&
              item.meta.icon != ''
              " :class="'font_family' + ' ' + item.meta.icon"></i>-->
            <span> {{ item.meta && item.meta.title && item.meta.title }}</span>
          </template>
          <!--递归组件，把遍历的值传回子组件，完成递归调用-->

          <SidebarPopover :basePath="item.path" :item="item" :activeId="activeId"
            @close="closePopover(item.id.toString() + '99999')"></SidebarPopover>
        </el-submenu>
      </template>

      <!--更多菜单-->
      <el-submenu :class="[
        'recombination-first-stage',
        'more-menu-stage',
        activeMenu == '#' ? 'is-active' : '',
      ]" :style="getMoreMenuStyle()" :popper-append-to-body="true" popper-class="more-menu-popper" menu-trigger="hover" :show-timeout="0" :hide-timeout="200" index="#99999" v-if="showIndex != -2 && showIndex < sidebarRouters.length">
        <template slot="title">
          <!--<i class="font_family icon-fengxianfenquguanli"></i>-->
          <span> 更多菜单</span>
        </template>
        <!--递归组件，把遍历的值传回子组件，完成递归调用-->

        <WholePopover @close="closePopover('#99999')" :activeId="activeId" :arr="JSON.parse(JSON.stringify(sidebarRouters)).splice(
          showIndex,
          sidebarRouters.length - showIndex
        )
          ">
        </WholePopover>
      </el-submenu>

      <!--更多菜单-->
    </el-menu>
  </div>
</template>

<script>
import SidebarPopover from "@/layout/components/Sidebar/SidebarPopover.vue";
import WholePopover from "@/layout/components/Sidebar/WholePopover.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    SidebarPopover,
    WholePopover,
  },
  props: ["selectvalue"],
  data() {
    return {
      companyData: {
        data: {},
      },
      sidebarRouters: [],

      showIndex: -2,
      activePopover: "",
      activeId: "#",
      menuResizeObserver: null,
      menuTextResizeObserver: null,
      measureCanvasCtx: null,
      lastAnimationIndex: 1,
    };
  },
  computed: {
    activeMenu() {
      let activeId = this.seekRouteID(
        this.sidebarRouters,
        this.$route.fullPath
      );
      let activeArr = activeId && activeId != "" ? activeId.split("-") : [];

      this.activeId =
        Array.isArray(activeArr) && activeArr.length > 0
          ? activeArr[activeArr.length - 1] + ""
          : "#";

      let activeStr =
        Array.isArray(activeArr) && activeArr.length > 0
          ? activeArr[0] + ""
          : "#";

      let k = -1;
      if (activeStr != "" && activeStr != "#") {
        for (let i = 0; i < this.sidebarRouters.length; i++) {
          if (
            this.sidebarRouters[i].id + "" &&
            this.sidebarRouters[i].id + "" != "" &&
            this.sidebarRouters[i].id + "" == activeStr
          ) {
            k = i;
            break;
          }
        }
      }
      activeStr = k < this.showIndex ? activeStr + "" : "#";
      this.activeId = activeId && activeId != "" ? "-" + activeId + "-" : "#";
      this.lastAnimationIndex = k != -1 && k < this.showIndex ? k + 1 : (this.showIndex > -1 ? this.showIndex : 0) + 1;
      this.$emit('refreshAnimation', this.lastAnimationIndex)
      return activeStr;
    },
  },

  created: function () {
    this.companyData.data = JSON.parse(localStorage.getItem("companyInfo"));
    let leftMenus = JSON.parse(localStorage.getItem("routeMenu"));
    for (let i of leftMenus) {
      for (let j of i.childList) {
        if (!j.icon) {
          j.icon = "icon-setting1";
        }
        for (let k of j.childList) {
          if (!k.icon) {
            k.icon = "icon-setting2";
          }
        }
      }
    }

    leftMenus.unshift({
      childList: [],
      gmtCreate: null,
      haveChild: 0,
      icon: "icon-fengxianfenquguanli",
      id: 8888,
      isMenu: 1,
      level: 2,
      menuName: "首页",
      parentId: 5,
      permissionCode: null,
      route: "/processManager",
      spare: "1",
      status: 0,
    });
    this.routeRTransform(leftMenus);
    this.sidebarRouters = leftMenus;

    this.screenRouters(this.sidebarRouters);
    this.$nextTick(() => {
      this.screenRouters(this.sidebarRouters);
    });
    window.addEventListener("resize", this.handleResize);
  },
  mounted() {
    this.$nextTick(() => {
      this.initMenuResizeObserver();
      this.screenRouters(this.sidebarRouters);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    if (this.menuResizeObserver) {
      this.menuResizeObserver.disconnect();
      this.menuResizeObserver = null;
    }
    if (this.menuTextResizeObserver) {
      this.menuTextResizeObserver.disconnect();
      this.menuTextResizeObserver = null;
    }
  },
  methods: {
    handleResize() {
      this.screenRouters(this.sidebarRouters);
    },
    initMenuResizeObserver() {
      if (this.menuResizeObserver || !this.$el || typeof ResizeObserver === "undefined") {
        return;
      }
      this.menuResizeObserver = new ResizeObserver(() => {
        this.screenRouters(this.sidebarRouters);
      });
      this.menuResizeObserver.observe(this.$el);
      this.initMenuTextResizeObserver();
    },
    initMenuTextResizeObserver() {
      if (typeof ResizeObserver === "undefined") {
        return;
      }
      if (!this.menuTextResizeObserver) {
        this.menuTextResizeObserver = new ResizeObserver(() => {
          this.screenRouters(this.sidebarRouters);
        });
      }
      this.$nextTick(() => {
        const labels = this.$el.querySelectorAll(
          ".recombination-first-stage > span, .recombination-first-stage .el-submenu__title > span"
        );
        this.menuTextResizeObserver.disconnect();
        labels.forEach(label => this.menuTextResizeObserver.observe(label));
      });
    },
    getMenuTitle(item) {
      return item && item.meta && item.meta.title ? String(item.meta.title).trim() : "";
    },
    // 用实际渲染字体测量文字宽度，避免字体大小调整后与 JS 预估宽度脱节。
    // 字体直接从真实菜单文字节点的计算样式读取，无需手动同步 CSS 改动。
    getMeasureCtx() {
      if (!this.measureCanvasCtx) {
        this.measureCanvasCtx = document.createElement("canvas").getContext("2d");
      }
      const sampleSpan = this.$el && this.$el.querySelector(".recombination-first-stage > span, .recombination-first-stage .el-submenu__title > span");
      const font = sampleSpan ? window.getComputedStyle(sampleSpan).font : "13px sans-serif";
      this.measureCanvasCtx.font = font;
      return this.measureCanvasCtx;
    },
    getMenuItemWidth(item) {
      const title = this.getMenuTitle(item);
      const ctx = this.getMeasureCtx();
      const textWidth = ctx.measureText(title).width;
      return Math.min(178, Math.max(76, Math.ceil(textWidth) + 34));
    },
    getMenuItemStyle(item) {
      const width = this.getMenuItemWidth(item);
      return {
        width: `${width}px`,
        minWidth: `${width}px`,
        maxWidth: `${width}px`,
      };
    },
    getMoreMenuStyle() {
      return {
        width: '86px',
        minWidth: '86px',
        maxWidth: '86px',
      };
    },
    screenRouters(arr) {
      const menuWidth = this.$el ? this.$el.clientWidth : 0;
      const moreMenuWidth = 94;
      const safeWidth = 8;
      const itemGapWidth = 6;
      const itemWidths = arr.map(item => this.getMenuItemWidth(item) + itemGapWidth);
      const totalWidth = itemWidths.reduce((total, width) => total + width, 0);
      const needsMoreMenu = totalWidth + safeWidth > menuWidth;
      const availableWidth = Math.max(0, menuWidth - safeWidth - (needsMoreMenu ? moreMenuWidth : 0));
      let usedWidth = 0;
      let visibleCount = 0;

      for (const itemWidth of itemWidths) {
        if (usedWidth + itemWidth > availableWidth) {
          break;
        }
        usedWidth += itemWidth;
        visibleCount++;
      }

      this.showIndex = needsMoreMenu ? visibleCount : arr.length;

      // 可见菜单项宽度/数量变化后（窗口尺寸变化、字体变化、容器大小变化等），
      // 通知外层重新测量高亮框位置，避免框跟文字对不上。当前激活项索引不变，
      // 仅触发一次重新计算，不会播放多余的切换动画。
      this.$nextTick(() => {
        this.$emit("refreshAnimation", this.lastAnimationIndex);
      });
    },
    seekRouteID(data, path) {
      if (data && Array.isArray(data)) {
        for (let i = 0; i < data.length; i++) {
          if (
            data[i].path == path &&
            path != null &&
            path != "null" &&
            path != undefined &&
            path != "undefined" &&
            path != ""
          ) {
            return data[i].id + "";
          }

          if (Array.isArray(data[i].children) && data[i].children.length > 0) {
            let ids = this.seekRouteID(data[i].children, path);
            if (ids != "") {
              return data[i].id + "-" + ids;
            }
          }
        }
      }
      return "";
    },
    setPermission(val) {
      localStorage.setItem(
        "Permission",
        JSON.stringify(
          Array.isArray(val.children) && val.children.length > 0
            ? val.children
            : [val]
        )
      );
      if (val.route === "/processManager/peopleOnline") {
        window.open(localStorage.getItem("companyMapUrl3"), "_blank");
        return;
      }
      this.$store.commit("add_tabs", { route: val.route, name: val.menuName });
      this.$router.push(val.route);
      this.indexVal = val.id;
    },

    //主动关闭
    closePopover(index) {
      let tablepopover = "menuId";
      if (index && index != "" && this.$refs[tablepopover]) {
        if (Array.isArray(this.$refs[tablepopover])) {
          for (let i = 0; i < this.$refs[tablepopover].length; i++) {
            this.$refs[tablepopover][i].close(index); //关闭
          }
        } else {
          this.$refs[tablepopover].close(index); //关闭
        }
      }
    },
    routeRTransform(data) {
      if (data && Array.isArray(data)) {
        for (let i = 0; i < data.length; i++) {
          let itemData = JSON.parse(JSON.stringify(data[i]));
          data[i] = {
            id: data[i].id,
            oldData: itemData,
            path: data[i].route,
            hidden: false,
            meta: {
              title: data[i].menuName,
              icon: data[i].icon,
            },
            children: Array.isArray(data[i].childList) ? data[i].childList : [],
          };

          let isDelete = false;

          if (itemData.haveChild === 0 && itemData.isMenu === 1) {
            //只有一级菜单
            data[i].children = [];
          } else if (itemData.childList && itemData.haveChild === 1) {
            //有多级菜单
          } else {
            isDelete = true;
          }

          if (isDelete) {
            data.splice(i, 1);
            i--;
          } else {
            if (data[i].children.length > 0) {
              this.routeRTransform(data[i].children);
            } else {
              delete data[i].children;
              if (!(data[i].path && data[i].path != "")) {
                data.splice(i, 1);
                i--;
              }
            }
          }
        }
      }
    },

    handleGet(index) {
      if (index === "/processManager/peopleOnline") {
        window.open(this.companyData.data.mapUrl, "_blank");
        return;
      }
      if (index != "/aaa") {
        this.$router.push({
          path: index,
        });
      }
    },
  },
};
</script>

<style scoped>
.el-menu-vertical-demo {
  text-align: left;
}

.recombination-custom-menu /deep/ .el-menu {
  border-right: none;
  display: flex;
  align-items: center;
  width: 100%;
  height: 54px;
  overflow: hidden;
  white-space: nowrap;
  border-bottom: none !important;
  background: none !important;
}

.recombination-custom-menu {
  width: 100%;
  height: 60px;
  display: block;
  overflow: hidden;
}
</style>  
<style lang="scss">
$primaryMenu: #00baff;

.recombination-custom-menu {
  .recombination-first-stage {
    // border-right: 1px solid #919191;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;
    flex: 0 0 auto;
    height: 54px !important;
    margin: 0 3px;
    box-sizing: border-box;
    padding: 0 !important;
    background: none;
    border-bottom: none !important;
    background: none !important;

    >i {
      line-height: 20px;
      margin: 0 !important;
      font-size: 20px;
      padding: 4px 0 8px 0 !important;
      color: #fff;
    }

    >span {
      line-height: 16px;
      font-size: 13px;
      display: block;
      width: 100%;
      padding: 0 4px;
      box-sizing: border-box;
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      letter-spacing: .2px;
    }

    >.el-submenu__title {
      padding: 0 4px !important;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-flow: column;
      width: 100%;
      height: 54px !important;
      line-height: 54px !important;
      box-sizing: border-box;
      background: none !important;
      border-bottom: none !important;

      >i {
        line-height: 20px;
        margin: 0 !important;
        font-size: 20px;
        padding: 4px 0 8px 0 !important;
        color: #fff;
      }

      >span {
        line-height: 16px;
        font-size: 13px;
        display: block;
        width: 100%;
        padding: 0 4px;
        box-sizing: border-box;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        letter-spacing: .2px;
      }

      >.el-icon-arrow-down {
        display: none !important;
      }

      >.el-menu--horizontal {
        background: #fff !important;
      }
    }

    .el-submenu__title {
      border-bottom: none !important;
    }

    >.el-menu--horizontal {
      background: #fff !important;
    }
  }

  .is-active {
    // background: $primaryMenu !important;
    background: none !important;

    >i {
      color: $primaryMenu !important;
    }

    >span {
      color: $primaryMenu !important;
    }

    >.el-submenu__title {
      >i {
        color: $primaryMenu !important;
      }

      >span {
        color: $primaryMenu !important;
      }
    }
  }

  .recombination-first-stage:hover {
    // background: $primaryMenu !important;
    background: none !important;

    >i {
      color: $primaryMenu !important;
    }

    >span {
      color: $primaryMenu !important;
    }

    >.el-submenu__title {
      >i {
        color: $primaryMenu !important;
      }

      >span {
        color: $primaryMenu !important;
      }
    }
  }

  .el-menu--popup {
    width: 400px;
    background: #fff !important;
    border: 1px solid #ebeef5 !important;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2) !important;
    border-radius: 4px !important;
    padding: 4px !important;
  }
}

.top-menu-popper {
  width: 320px !important;
  max-width: calc(100vw - 32px) !important;
  max-height: calc(100vh - 92px) !important;
  overflow: hidden !important;
  padding: 8px !important;
  background: #eef6ff !important;
  border: 1px solid rgba(0, 186, 255, .35) !important;
  border-radius: 6px !important;
  box-shadow: 0 8px 22px rgba(0, 25, 55, .22) !important;
  box-sizing: border-box;
  z-index: 3000 !important;
}

.top-menu-popper .el-menu--popup {
  width: auto !important;
  min-width: 0 !important;
  padding: 0 !important;
  border: none !important;
  box-shadow: none !important;
  background: #eef6ff !important;
}

.top-menu-popper.el-menu--horizontal,
.top-menu-popper .el-menu--horizontal {
  border-bottom: none !important;
  background: #eef6ff !important;
}

.top-menu-popper .el-menu {
  border: none !important;
  background: #eef6ff !important;
}

.more-menu-popper {
  width: 280px !important;
  max-width: calc(100vw - 32px) !important;
  max-height: calc(100vh - 92px) !important;
  overflow: hidden !important;
  padding: 8px !important;
  background: #eef6ff !important;
  border: 1px solid rgba(0, 186, 255, .35) !important;
  border-radius: 6px !important;
  box-shadow: 0 8px 22px rgba(0, 25, 55, .22) !important;
  box-sizing: border-box;
}

.more-menu-popper .el-menu--popup {
  width: auto !important;
  min-width: 0 !important;
  padding: 0 !important;
  border: none !important;
  box-shadow: none !important;
  background: #eef6ff !important;
}

.more-menu-popper.el-menu--horizontal,
.more-menu-popper .el-menu--horizontal {
  border-bottom: none !important;
  background: #eef6ff !important;
}

.more-menu-popper .el-menu {
  border: none !important;
  background: #eef6ff !important;
}

@media (max-width: 768px) {
  .top-menu-popper,
  .more-menu-popper {
    width: calc(100vw - 24px) !important;
  }
}
</style>  
